import {Injectable} from '@angular/core';
import {Response, Headers, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Message} from '../models/message';
import 'rxjs/add/operator/map';
import { FileList } from '../models/file';

@Injectable()
export class FilesService {

  private fileUrl: string = `${ environment.apiRoot }/doc-list/`;

  constructor(private http: HttpAuth) { }

  public getDoclists(page?: number, pagecount?: number, query?: string, status?: any[]): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (query) {
        params.set('query', query);
    }

    if (status) {
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.fileUrl, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'server error', status:0}));
  }

  public getList(id: number): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('id', String(id));

    let options = new RequestOptions({search: params});

    return this.http.get(this.fileUrl, options)
      .map(this.extractData)
      .catch((error:any) => Observable.throw(error.json().meta || {message:'server error', status:0}));
  }

  public putList(file:FileList): Observable<FileList> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.fileUrl,file,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postList(file:FileList): Observable<FileList> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.fileUrl,file,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putListStatus(id, status): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {id:id,status:status};

    let options = new RequestOptions({search: params});

    return this.http.put(this.fileUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteList(doclist): Observable<FileList> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey,
      'id': doclist
    });

    return this.http.delete(this.fileUrl+"?id="+doclist,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/files.service.ts